import ApiService from "@/core/services/api.service";

// action types
export const GET_STATS_DAILY = "getStatsDaily";
export const GET_STATS_AMMOUNT = "getStatsAmmount";
export const GET_STATS_METHODS = "getStatsMethods";
// mutation types
export const SET_STATS_DAILY = "setStatsDaily";
export const SET_STATS_AMMOUNT = "setStatsAmmount";
export const SET_STATS_METHODS = "setStatsMethod";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  dailyStats: [],
  dailyAmmountStats: [],
  methodStats:[]
};

const actions = {
  [GET_STATS_DAILY](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/Estadistica/v1/diarias`}, '')
        .then(({ data }) => {
          context.commit(SET_STATS_DAILY, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_STATS_AMMOUNT](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/Estadistica/v1/montos`}, '')
        .then(({ data }) => {
          context.commit(SET_STATS_AMMOUNT, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
    },
    [GET_STATS_METHODS](context) {
        return new Promise(resolve => {
          ApiService.setHeader();
          ApiService.get({action: `/api/Estadistica/v1/metodos`}, '')
            .then(({ data }) => {
                console.log('metodos ' + JSON.stringify(data));
              context.commit(SET_STATS_METHODS, data);
              resolve(data);
            })
            .catch(({ response }) => {
              console.log('err' + response);
              context.commit(SET_ERROR, '');//response.data.errors);
            });
        });
        }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_STATS_DAILY](state, data) {
    state.error = {};
    state.dailyStats = data;
  },
  [SET_STATS_AMMOUNT](state, data) {
    state.error = {};
    state.dailyAmmountStats = data;
  },
  [SET_STATS_METHODS](state, data) {
    state.error = {};
    state.methodStats = data;
  }
};

export default {
  state,
  actions,
  mutations
};
